// @flow
import * as React from 'react';
import styled, {keyframes} from 'styled-components';
import {BackgroundImage} from 'components/Image'
import {LayoutWrapper, useLayoutState} from 'components/Layout'
import StartImage from 'assets/images/driving-zone/img-count-0-big.svg'
import * as AudioUtils from 'utils/audioUtils';

type Props = {
  countdown: number,
};

export default function Guide(props: Props): React.Element<any> {
  const layoutState = useLayoutState();
  const countdown = props.countdown;
  React.useEffect(()=>{
    //AudioUtils.playBGM_UI();
    if (countdown === 3 || countdown === 2 || countdown === 1) {
      AudioUtils.play_countdown_01();
    }
    else if (countdown === 0) {
      AudioUtils.play_countdown_02();
    }
    else if (countdown === 4) {
      AudioUtils.play_goal_finish();
      AudioUtils.stop_motor02();
      
    }

    return ()=>{
    };
  }, [countdown]);

  return <LayoutWrapper>
    {props.countdown === 1 && <Wrapper>
      <ImageWrapper datawidth={layoutState.mobile ? 130 : 208} dataheight={layoutState.mobile ? 324 : 518} datax={layoutState.mobile ? 11.8 : 8.4} datay={0}>
        <ImageBGSlideTop source="./driving-zone/img-count-1-line.png" />
        <ImageNumber source="./driving-zone/img-count-1.png" datawidth={layoutState.mobile ? 62 : 103} dataheight={layoutState.mobile ? 159 : 258} datax={layoutState.mobile ? 20: 30} datay={layoutState.mobile ? 38 : 107} />
      </ImageWrapper>
    </Wrapper>}
    {props.countdown === 2 && <Wrapper>
      <ImageWrapper datawidth={layoutState.mobile ? 272 : 435} dataheight={layoutState.mobile ? 308 : 541} datax={0} datay={0}>
        <ImageBGSlideLeftTop source={layoutState.mobile ? "./driving-zone/img-count-2-line.png" : "./driving-zone/img-count-2-line-d.png"} />
        <ImageNumber source="./driving-zone/img-count-2.png" datawidth={layoutState.mobile ? 104 : 169} dataheight={layoutState.mobile ? 159 : 258} datax={layoutState.mobile ? 71 : 112} datay={layoutState.mobile ? 38 : 106} />
      </ImageWrapper>
    </Wrapper>}
    {props.countdown === 3 && <Wrapper>
      <ImageWrapper datawidth={layoutState.mobile ? 259 : 415} dataheight={layoutState.mobile ? 322 : 516} datax={0} datay={layoutState.mobile ? 2 : 7}>
        <ImageBGSlideLeftBottom source="./driving-zone/img-count-3-line.png" />
        <ImageNumber source="./driving-zone/img-count-3.png" datawidth={layoutState.mobile ? 113 : 184} dataheight={layoutState.mobile ? 159 : 258} datax={layoutState.mobile ? 64 : 101} datay={layoutState.mobile ? 29 : 45} />
      </ImageWrapper>
    </Wrapper>}
    {props.countdown === 0 && <Wrapper>
      <ImageWrapper datawidth={layoutState.mobile ? 573 : 1047} dataheight={layoutState.mobile ? 130 : 151} datax={0} datay={layoutState.mobile ? 35 : 42.7}>
      <ImageBGFadeOut source="./driving-zone/img-count-0-line.png" />
      </ImageWrapper>
      <ImageNumberZoomIn datawidth={layoutState.mobile ? 264 : 417} dataheight={layoutState.mobile ? 64 : 100} >
        <img src={StartImage} alt="Start" />
      </ImageNumberZoomIn>
    </Wrapper>}
    {props.countdown === 4 && <Wrapper>
      <ImageNumberZoomOut datawidth={layoutState.mobile ? 650 : 1017} dataheight={layoutState.mobile ? 112 : 175} >
        <ImageBG source="./driving-zone/finish.png" />
      </ImageNumberZoomOut>
    </Wrapper>}
  </LayoutWrapper>
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const ImageWrapper = styled.div`
  position:absolute;
  left: ${props => props.datax}%;
  top: ${props => props.datay}%;
  width: ${props => props.datawidth}px;
  height: ${props => props.dataheight}px;
`;

const ImageBG = styled(BackgroundImage)`
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
`;

const SlideTop = keyframes`
  to {
    transform: translate(0, -50%);
  }
`;

const SlideLeftTop = keyframes`
  to {
    transform: translate(-10vw, -10vw);
  }
`;

const SlideLeftBottom = keyframes`
  to {
    transform: translate(-10vw, 10vw);
  }
`;

const FadeOut = keyframes`
  to {
    opacity: 0;
  }
`;

const ZoomIn = keyframes`
  to {
    transform: scale(2);
  }
`;

const ZoomOut = keyframes`
  from {
    opacity: 0;
    transform: scale(2);
  }
  50% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale(0.5);
  }
`;


const ImageBGSlideTop = styled(ImageBG)`
  animation: ${SlideTop} 1s; 
  animation-fill-mode: forwards;
  
`;

const ImageBGSlideLeftTop = styled(ImageBG)`
  animation: ${SlideLeftTop} 1s; 
  animation-fill-mode: forwards;
`;

const ImageBGSlideLeftBottom = styled(ImageBG)`
  animation: ${SlideLeftBottom} 1s; 
  animation-fill-mode: forwards;
`;

const ImageBGFadeOut = styled(ImageBG)`
  animation: ${FadeOut} 1s; 
`;

const ImageNumber = styled(BackgroundImage)`
  position:absolute;
  left: ${props => props.datax}px;
  top: ${props => props.datay}px;
  width: ${props => props.datawidth}px;
  height: ${props => props.dataheight}px;
  background-repeat: no-repeat;
  background-size: contain;
`;

const ImageStart = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    width: ${props => props.datawidth}px;
    height: ${props => props.dataheight}px;
  }
`;

const ImageNumberZoomIn = styled(ImageStart)`
  animation: ${ZoomIn} 1s; 
`;

const ImageNumberZoomOut = styled(ImageStart)`
  opacity: 0;
  animation: ${ZoomOut} 2s; 
`;